import React from "react";

import { BillIcon } from "../../../icons";
import { CreditActivity } from "../../../api/services";
import { ActivityListItem } from "./ActivityListItem";
import { useCreditActivity } from "../hooks/useCreditActivity";
import { ActivityTitle } from "./ActivityTitle";
import { ActivitySummaryCell } from "./ActivitySummaryCell";

export const CreditActivityItem: React.FC<{
  activity: CreditActivity;
}> = ({ activity }) => {
  const { title, link, billPeriod } = useCreditActivity(activity);
  const { activityDttm } = activity;
  return (
    <ActivityListItem
      icon={<BillIcon />}
      title={
        <ActivityTitle whiteSpace="nowrap">
          {title}
          {billPeriod ? `Period ${billPeriod}` : null}
        </ActivityTitle>
      }
      activityDttm={activityDttm}
      linkTo={link}
    />
  );
};

export const CreditActivitySummaryCell: React.FC<{
  activity: CreditActivity;
  isGrey: boolean;
}> = ({ activity, isGrey }) => {
  const { title, billPeriod } = useCreditActivity(activity);
  return (
    <ActivitySummaryCell
      icon={<BillIcon />}
      isGrey={isGrey}
      summary={title + (billPeriod ? ` (Period ${billPeriod})` : "")}
    />
  );
};
